import { cn } from "@theprelude/core";
import { LoaderIcon } from "../icons/loader-icon";

export const Loading: React.FC<{
  className?: string;
  "data-testid"?: string;
}> = ({ className, "data-testid": dataTestId }) => {
  return (
    <LoaderIcon
      className={cn("mx-auto my-0 animate-spin", className)}
      data-testid={dataTestId}
    />
  );
};
